import React from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';
import { Emoji } from 'emoji-mart'

import { PopOut } from 'components'
import { IconInput } from 'features'
import { FaFileAlt } from 'react-icons/fa';

const defaultStyle = {
    margin: 0,
    padding: '0.5rem',
    backgroundColor: 'var(--primary-color)',
    size: '1rem'
}

const Container = styled.div`
    cursor: ${props => props.cursor};
    outline: none;
    display: flex;
    justify-content: flex-start;
    align-items:center;
`

const Image = styled.div`
    width: ${props => props.size ? props.size : '1rem'};
    height: ${props => props.size ? props.size : '1rem'};
    object-fit: cover;
`

const IconContainer = styled.div`
    padding: ${props => props.styles.padding};
    margin: ${props => props.styles.margin};
    color: ${props => props.styles.color};
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    line-height: 1px;
    :hover{
        filter: brightness(var(--brightness));
    }
`

const Icon = props => {
    const {
        value,
        type,
        size,
        defaultIcon,
        styles,
        onSubmit,
    } = props;
    let updatedStyle = Object.assign({}, defaultStyle, styles)

    let icon = null
    if(type === 'emoji'){
        icon = <Emoji emoji={value} size={size ? parseFloat(size.replace('rem',''))*16 : 16}/>
    } else if (type === 'link' | type === 'file') {
        icon = <Image size={size || '1rem'}>
                    <img src={value} style={{width:'100%', height:'100%',objectFit:'contain', borderRadius: '5px'}}/>
                </Image>
    } else {
        icon = defaultIcon || <Image size={size || '1rem'}><FaFileAlt style={{width: '100%', height: '100%', fontSize: size || '1rem'}}/></Image>
    }

    const iconInput = <IconInput onSubmit={onSubmit}/>

    return (
        <Container cursor={onSubmit ? 'pointer' : 'auto'} styles={updatedStyle}>
            {onSubmit ? <PopOut trigger='leftClick' element={iconInput}><IconContainer styles={updatedStyle}>{icon}</IconContainer></PopOut> 
            : <IconContainer styles={updatedStyle}>{icon}</IconContainer>}
        </Container>
    )
}

export default Icon;

// Icon.propTypes = {
//     value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
//     type: PropTypes.oneOf(['emoji','link','file']),
//     size: PropTypes.string,
//     iconInput: PropTypes.element,
//     defaultIcon: PropTypes.element
// }